'use client'

import { useEffect, useState } from 'react'

export default function ScrollIndicator() {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    // Hide scroll indicator after user scrolls down
    let timeoutId: NodeJS.Timeout
    
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsVisible(false)
      } else {
        setIsVisible(true)
      }
    }

    // Debounce scroll handler for better performance
    const debouncedHandleScroll = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(handleScroll, 100)
    }

    window.addEventListener('scroll', debouncedHandleScroll, { passive: true })
    
    return () => {
      clearTimeout(timeoutId)
      window.removeEventListener('scroll', debouncedHandleScroll)
    }
  }, [])

  const handleScrollClick = () => {
    const nextSection = document.querySelector('section:nth-of-type(2)');
    if (nextSection) {
      // Use scrollTo for better control and performance
      const targetPosition = nextSection.getBoundingClientRect().top + window.scrollY
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      })
    }
  };

  return (
    <div 
      className={`absolute bottom-8 left-1/2 -translate-x-1/2 z-10 lg:bottom-12 transition-opacity duration-500 ${
        isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
    >
      <button
        onClick={handleScrollClick}
        className="flex flex-col items-center gap-2 text-white/80 hover:text-white transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50 rounded-lg p-2 touch-manipulation"
        aria-label="Scroll to next section"
      >
        <span className="text-xs font-medium tracking-wider uppercase hidden sm:block">Scroll</span>
        <div className="scroll-indicator-bounce">
          <svg 
            className="w-6 h-6 sm:w-7 sm:h-7" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </button>
    </div>
  );
}
